import React from 'react';

function ClaimEnquiry() {
  return <div>ClaimEnquiry</div>;
}

export default ClaimEnquiry;
